import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Grid/Grid.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var Grid = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:grid", className)
  }, rest), {
    children
  }));
});
var StoryGrid = args => /* @__PURE__ */jsx(Grid, __spreadValues({}, args));
var Grid_default = Grid;
export { StoryGrid, Grid_default };